export const initNavbarScroll = () => {
    const landingMenu = document.getElementById( 'landingMenu' );

    const calculateNavbarOffset = ( navbar ) => {
        if ( ! navbar ) {
            return 0;
        }
        const { paddingTop, paddingBottom } = getComputedStyle( navbar );
        let offset = 0;

        if ( landingMenu ) {
            const header = document.querySelector( '.mobile-header' );
            offset = header ? header.offsetHeight : 0;
        }

        if ( ! navbar.classList.contains( 'd-none' ) ) {
            const compensation = window.innerWidth < 992 ? 0 : 7;
            offset += navbar.offsetHeight - parseInt( paddingTop ) - parseInt( paddingBottom ) - compensation;
        }
        return offset;
    };

    const handleLandingMenuScroll = () => {
        if ( ! landingMenu ) {
            return;
        }

        const navbar = landingMenu.querySelector( '.navbar' );
        if ( ! navbar ) {
            return;
        }

        const menuPosition = landingMenu.getBoundingClientRect().top;
        const threshold = window.innerWidth < 992 ? 69 : 0;
        const isFixed = menuPosition <= threshold;

        const navbarOffset = `${ calculateNavbarOffset( navbar ) / 16 }rem`;
        navbar.classList.toggle( 'fixed-top', isFixed );
        landingMenu.classList.toggle( 'menu-fixed-compensation', isFixed );

        if ( isFixed ) {
            landingMenu.style.setProperty( '--navbar-offset', navbarOffset );
        } else {
            landingMenu.style.removeProperty( '--navbar-offset' );
        }
        const mobilePopup = document.querySelector( '.popup-mobile' );
        if ( mobilePopup ) {
            const width = window.innerWidth;

            mobilePopup.classList.toggle( 'compensation', isFixed && width >= 992 && width <= 1200 );

            mobilePopup.classList.toggle( 'position-fixed', isFixed && width < 1200 );
        }
    };

    const handleHashFragmentScroll = () => {
        if ( window.location.hash ) {
            const targetElement = document.querySelector( window.location.hash );
            if ( targetElement ) {
                setTimeout( () => {
                    targetElement.scrollIntoView( { behavior: 'auto', block: 'start' } );
                }, 0 );
            }
        }
    };

    const handleScroll = () => {
        if ( landingMenu ) {
            handleLandingMenuScroll();
        }
    };

    const handleResize = () => {
        if ( landingMenu ) {
            const navbar = landingMenu.querySelector( '.navbar' );
            if ( navbar ) {
                navbar.classList.remove( 'fixed-top' );
                landingMenu.classList.remove( 'menu-fixed-compensation' );
                landingMenu.style.removeProperty( '--navbar-offset' );
            }
        }

        handleScroll();
    };

    window.addEventListener( 'scroll', handleScroll );
    window.addEventListener( 'resize', handleResize );
    window.addEventListener( 'load', handleHashFragmentScroll );

    handleScroll();
    handleHashFragmentScroll();

    return () => {
        window.removeEventListener( 'scroll', handleScroll );
        window.removeEventListener( 'resize', handleResize );
        window.removeEventListener( 'load', handleHashFragmentScroll );
    };
};
